import React from 'react';
import { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import { useLocation } from "react-router-dom";
// Tus páginas
// eslint-disable-next-line
import HomeView from './Pages/HomeView';
import Evento from './Pages/Evento';
import Fiesta from "./Pages/Fiesta";

import Contacto from './Pages/Contacto';
import PuestoVenta from './Pages/PuestoVenta';
import Grilla from './Pages/Grilla';
import Cargando from './Pages/Cargando';
import Sectores from "./Pages/Sectores";
import Cierre from './Pages/Cierre';
// Nuevas páginas de entradas
import EntradaSection from './Pages/EntradaSection';
import SpotifyFloatingPlayer from './Pages/SpotifyFloatingPlayer';
import { trackPageView } from "./Pages/analytics";
// El evento ya terminó: true = todo el sitio muestra sólo la placa de cierre
// (Pages/Cierre.js). Poné false para volver al sitio completo.
const EVENTO_FINALIZADO = true;

function App() {
	const location = useLocation();
  const appStyle = {
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1,
  };

 useEffect(() => {
   trackPageView(location.pathname + location.search);
 }, [location]);
  if (EVENTO_FINALIZADO) {
    return <Cierre />;
  }
  return (
    <Router>
      <div className="App" style={appStyle}>
        <header>
          {/* La pelota animada si querés mantenerla */}
          {/* <div style={ballStyle}></div> */}

          <Switch>
            {/* Rutas principales */}
           <Route exact path="/" component={HomeView} />
            {/* <Route exact path="/" component={Cargando} /> */}
            <Route path="/evento" component={Evento} />
            <Route path="/sectores" component={Sectores} />
            <Route path="/contacto" component={Contacto} />
            <Route path="/puestoventa" component={PuestoVenta} />
            <Route path="/grilla" component={Grilla} />
            <Route path="/HomeView" component={Cargando} />
            <Route path="/fiesta" component={Fiesta} />

            {/* Rutas de entradas */}
            <Route path="/entrada-general" render={() => <EntradaSection tierKey="pulso" />} />
            <Route path="/entrada-vip" render={() => <EntradaSection tierKey="orbita" />} />
            <Route path="/entrada-platea-vr" render={() => <EntradaSection tierKey="orbita-vr" />} />
          </Switch>
        </header>
      </div>

      <SpotifyFloatingPlayer />
    </Router>
  );
}

export default App;
